import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface AdminNotificationSettings {
  newRegistrationEnabled: boolean;
  /** Comma-separated override; empty means "all active admins". */
  newRegistrationRecipients: string | null;
  /** Read-only: who would actually be mailed right now. */
  effectiveRecipients: string[];
}

export const adminGetNotificationSettings = async (token: string): Promise<AdminNotificationSettings> => {
  const res = await axios.get(`${API_BASE}/admin/notifications`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const adminUpdateNotificationSettings = async (
  payload: Pick<AdminNotificationSettings, 'newRegistrationEnabled' | 'newRegistrationRecipients'>,
  token: string,
): Promise<AdminNotificationSettings> => {
  const res = await axios.put(`${API_BASE}/admin/notifications`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};
